var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 19,
    viewBox: "0 0 40 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.5C0 4.256 4.256 0 9.5 0C14.744 0 19 4.256 19 9.5C19 14.744 14.744 19 9.5 19C4.256 19 0 14.744 0 9.5ZM1.9 9.5C1.9 13.699 5.301 17.1 9.5 17.1C13.699 17.1 17.1 13.699 17.1 9.5C17.1 5.301 13.699 1.9 9.5 1.9C5.301 1.9 1.9 5.301 1.9 9.5Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0C4.256 0 0 4.256 0 9.5C0 14.744 4.256 19 9.5 19C14.744 19 19 14.744 19 9.5C19 4.256 14.744 0 9.5 0ZM9.5 17.1C5.301 17.1 1.9 13.699 1.9 9.5C1.9 5.301 5.301 1.9 9.5 1.9C13.699 1.9 17.1 5.301 17.1 9.5C17.1 13.699 13.699 17.1 9.5 17.1ZM14.25 9.5C14.25 12.1234 12.1234 14.25 9.5 14.25C6.87665 14.25 4.75 12.1234 4.75 9.5C4.75 6.87665 6.87665 4.75 9.5 4.75C12.1234 4.75 14.25 6.87665 14.25 9.5Z",
    fill: "#006485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9.5C21 4.256 25.256 0 30.5 0C35.744 0 40 4.256 40 9.5C40 14.744 35.744 19 30.5 19C25.256 19 21 14.744 21 9.5ZM22.9 9.5C22.9 13.699 26.301 17.1 30.5 17.1C34.699 17.1 38.1 13.699 38.1 9.5C38.1 5.301 34.699 1.9 30.5 1.9C26.301 1.9 22.9 5.301 22.9 9.5Z",
    fill: "#006485"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.eec0d1cf4d3186dd61d23765ea9fa85b.svg";
export { ForwardRef as ReactComponent };